import Vue from "vue";
let currentRequest = 0;

const FolderService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("folder", id, {
        include: "permalink,tagging,tagging.tag" //"customer,services,tenant,agreementServices,invoice_periods,invoices"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      searchFilterPagination.include = "permalink,tagging,tagging.tag"
      const request = ++currentRequest;
      console.log(`[${request}] START FOLDER `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "folders",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] FOLDER DISCARDED`);
        return null;
      }
      console.log(`[${request}] END FOLDER `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("folder", payload);
      } else {
        return await Vue.$jsonApi.update("folder", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("folder", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { FolderService };
